import { render, staticRenderFns } from "./manageRespondents.vue?vue&type=template&id=2403b0ad&"
import script from "./manageRespondents.vue?vue&type=script&lang=js&"
export * from "./manageRespondents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports